// Dashboard.js
import React, { useEffect, useState } from "react"
import { Container, Row, Col, Card, Table, Button } from "react-bootstrap"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
import { db } from "./../firebase"
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  Timestamp,
  updateDoc,
  collectionGroup,
  getDocs,
} from "firebase/firestore"
import { postHttp } from "../api/HttpClient"
import VerifyPayment from "./VerifyPayment"
import { useAuth } from "../contexts/AuthContext"

// import PaymentStatusComponent from "./PaymentStatusComponent";

const Dashboard = () => {
  const [loading, setLoading] = useState(false)
  const { currentUser, logout, currentAdmin, currentBecario } = useAuth()

  const paymentStatus = async (user) => {
    setLoading(true)
    const body = {
      order_owner: "Qr",
      payment_id: user.payment_id,
    }
    const docRef = doc(db, "users", user.uid)

    if (user.payment_id > 0) {
      const { response, success, errorData, message } = await postHttp(
        "verify",
        body
      )
      console.log("QR response: ", response)
      try {
        if (response.state === 2) {
          // Update database when QR paid
          const paymentTimeStamp = new Date(Timestamp.now().toDate().toString())

          const dateStampUse = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(paymentTimeStamp)

          // await updateDoc(docRef, "subscription", true)
          // await updateDoc(docRef, "status", response?.state)
          // await updateDoc(docRef, "lastPayment", dateStampUse)
          // await updateDoc(docRef, "certificate", true)
          // await updateDoc(docRef, "vegetarianOption", false)

          alert("QR pagado")
        } else if (response.state === 6) {
          alert("QR vencido (codigo: 6)")

          // await updateDoc(docRef, "subscription", false)
          // await updateDoc(docRef, "status", 0)
          // await updateDoc(docRef, "payment_id", 0)
        } else if (response.state === "98") {
          alert("QR vencido (codigo: 98)")
          // await updateDoc(docRef, "subscription", false)
          // await updateDoc(docRef, "status", 0)
          // await updateDoc(docRef, "payment_id", 0)
        } else {
          alert("QR pendiente")
        }
      } catch {
        console.log("errorData", errorData)
        console.log("message", message)
        alert(
          "QR error:",
          "payment_id = " + body.payment_id + " did not return response"
        )
      }
    } else {
      alert("User has no active QR")

      // await updateDoc(docRef, "subscription", false)
      // await updateDoc(docRef, "status", 0)
      // await updateDoc(docRef, "payment_id", 0)
    }

    setLoading(false)
  }

  const cardStyle = {
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    marginBottom: "20px",
    textAlign: "center",
    minHeight: "50px",
  }

  const headerStyle = {
    textAlign: "center",
    marginBottom: "40px",
    fontSize: "24px",
    fontWeight: "bold",
  }

  const titleStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  }

  const valueStyle = {
    color: "#007bff",
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "10px",
  }

  const descriptionStyle = {
    fontSize: "14px",
    color: "#555",
  }

  // Format the payment date field
  function formatTimestamp(input) {
    // Check if the input is already a string (assuming it's in toLocaleString format)
    if (typeof input === "string") {
      return input // If it's already formatted, return it directly
    }

    // Otherwise, check if it's in Firestore timestamp format (object with 'seconds' and 'nanoseconds')
    if (
      input &&
      typeof input === "object" &&
      "seconds" in input &&
      "nanoseconds" in input
    ) {
      // Convert seconds to milliseconds and create a Date object
      const date = new Date(input.seconds * 1000)

      // Format the date to "YYYY-MMM-DD HH:MM"
      const options = {
        year: "numeric",
        month: "2-digit", // "short" gives the abbreviated month name (e.g., Jan, Feb)
        day: "2-digit",
      }

      // Format the date string using Intl.DateTimeFormat
      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        date
      )

      return formattedDate
    }

    // If input is neither a string nor a Firestore timestamp, return an error message or fallback
    return "Invalid timestamp format"
  }

  const [users, setUsers] = useState([])

  // Query all users with some confirmed or pending payment
  // const currentDataQuery = query(
  //     collection(db, "users"),
  //     where("status", ">", 0),
  // );

  const currentDataQuery = query(
    collection(db, "subscriptions"),
    where("year", "in", [2025, 2026]),
    where("status", ">=", 1)
  )

  // const currentDataQuery = query(collectionGroup(db, "subscriptions"))
  // const currentDataQuery = query(
  //   collection(db, "subscriptions"),
  //   where("year", "==", 2025)
  // )

  // Hook for paid users
  useEffect(() => {
    const unsubCol = onSnapshot(currentDataQuery, (snapshot) => {
      setUsers(snapshot.docs.map((doc) => doc.data()))
    })

    return () => unsubCol()
  }, [])

  // useEffect(() => {
  //   const fetchStaticData = async () => {
  //     try {
  //       const snapshot = await getDocs(currentDataQuery) // Fetch static data
  //       setUsers(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))) // Map the data to include document IDs
  //     } catch (error) {
  //       console.error("Error fetching static data:", error)
  //     }
  //   }

  //   fetchStaticData() // Call the function to fetch data
  // }, []) // Empty dependency array ensures this runs only once

  // console.log(users)
  const subscribedUsersAll = users.filter((users) => {
    return users.status === 2
  })
  const pendingUsesAll = users.filter((users) => {
    return users.status === 1
  })
  // console.log(pendingUsesAll)
  // console.log("Subscribed Users All: ", subscribedUsersAll)
  // Usuarios inscritos
  const subscribedUsers = subscribedUsersAll
    .filter((user) => user.status === 2)
    .map((user) => ({
      name: user.name,
      email: user.email,
      affiliation: user.affiliation,
      categoria: user.category,
      date: formatTimestamp(user.lastPayment),
      vegetarianOption: user.vegetarianOption,
      certificate: user.certificate,
      payment_id: user.payment_id || "",
      // vegan: user.
    }))
    .sort((a, b) => {
      // Sort by date (oldest first)
      return new Date(a.date) - new Date(b.date)
    })
    .map((user, index) => ({
      ...user,
      id: index + 1, // Assign consecutive IDs after sorting
    }))

  // Categorias para grafico de barras
  const userCategoryData = [
    { category: "Expositor", card: 0, qr: 0, total: 0 },
    { category: "Professional", card: 0, qr: 0, total: 0 },
    { category: "Student", card: 0, qr: 0, total: 0 },
    // { category: 'Invitado', card: 0, qr: 0, total: 0 },
  ]

  const categoryIndex = {
    Expositor: 0,
    Professional: 1,
    Student: 2,
    // 'Invitado': 3,
  }

  // console.log(subscribedUsersAll)

  subscribedUsersAll.forEach((user) => {
    const categoryIdx = categoryIndex[user.category] // Find the index for the user's category

    // Skip if category is not found in the index
    if (categoryIdx === undefined) {
      console.warn(`Unknown category "${user.category}" for user:`, user.email)
      return
    }

    if (user.paymentType === "Stripe") {
      userCategoryData[categoryIdx].card += 1 // Increment the card count for that category
    } else if (user.paymentType === "QR") {
      userCategoryData[categoryIdx].qr += 1 // Increment the credit count for that category
    }
    // After updating the card/credit count, update the total
    userCategoryData[categoryIdx].total =
      userCategoryData[categoryIdx].card + userCategoryData[categoryIdx].qr
  })

  const expositorTotalRevenue =
    userCategoryData[categoryIndex["Expositor"]].total * 320 +
    userCategoryData[categoryIndex["Professional"]].total * 320 +
    userCategoryData[categoryIndex["Student"]].total * 180

  const handlePaymentUpdate = (updatedPayment) => {
    // Update the local state or perform any additional actions
    console.log("Payment updated:", updatedPayment)

    // Optionally, refresh the list of users
    // setUsers((prevUsers) =>
    //   prevUsers.map((user) =>
    //     user.payment_id === updatedPayment.payment_id ? updatedPayment : user
    //   )
    // )
  }

  // console.log("Current User: ", currentUser)
  // console.log("Current Admin: ", currentAdmin)
  return (
    <Container fluid>
      <h2 className='mt-3' style={headerStyle}>
        Panel de Administración <br /> SEBOL - BCDE 15
      </h2>

      {/* Summary Cards */}
      <Row>
        <Col md={4}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>Usuarios inscritos</Card.Title>
              <div>
                <p style={valueStyle}>{subscribedUsersAll.length}</p>
                <p style={descriptionStyle}>Total usuarios inscritos </p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>QRs pendientes</Card.Title>
              <div>
                <p style={valueStyle}>{pendingUsesAll.length}</p>
                <p style={descriptionStyle}>Verificar QRs</p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>Ingresos</Card.Title>
              <div>
                <p style={valueStyle}>Bs. {expositorTotalRevenue}</p>
                <p style={descriptionStyle}>Ingresos por inscripciones</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Table for Subscribed Users */}
      <Row>
        <Col md={12}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>
                Lista de Usuarios Confirmados
              </Card.Title>
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  bordered
                  hover
                  responsive='sm'
                  style={{ textAlign: "left" }}
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>QR</th>
                      <th>Nombre</th>
                      <th>Email</th>
                      <th>Afiliación</th>
                      <th>Categoria</th>
                      <th>Fecha de inscripción</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscribedUsers.map((user) => (
                      <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>
                          {typeof user.payment_id != "string"
                            ? user.payment_id
                            : "Stripe"}
                        </td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.affiliation}</td>
                        <td>{user.categoria}</td>
                        <td>{user.date}</td>
                        <td>
                          {user.vegetarianOption && (
                            <span
                              style={{
                                backgroundColor: "#BA55FF",
                                color: "white",
                                padding: "2px 10px",
                                borderRadius: "100px",
                                fontSize: "10px",
                                display: "block", // Ensures the span takes the full width and stacks vertically
                                marginBottom: "5px", // Adds space between stacked elements
                              }}
                            >
                              {"Vegetariano"}
                            </span>
                          )}

                          {user.certificate && (
                            <span
                              style={{
                                maxWidth: "90px",
                                backgroundColor: "green",
                                color: "white",
                                padding: "2px 10px",
                                borderRadius: "100px",
                                fontSize: "10px",
                                display: "block", // Ensures the span takes the full width and stacks vertically
                                marginBottom: "5px", // Adds space between stacked elements
                              }}
                            >
                              {"Certificado"}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Table for Pending Users */}
      <Row>
        <Col md={12}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>QRs pendiente de pago</Card.Title>
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  bordered
                  hover
                  responsie='sm'
                  style={{ textAlign: "left" }}
                >
                  <thead>
                    <tr>
                      <th># QR</th>
                      <th>Nombre</th>
                      <th>Email</th>
                      <th>Afiliación</th>
                      <th>Categoria</th>
                      <th>Validez QR</th>
                      <th>Verificar QR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingUsesAll.map((user) => (
                      <tr key={user.uid}>
                        <td>{user.payment_id}</td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.affiliation}</td>
                        <td>{user.category}</td>
                        <td>{user.expiration_date}</td>
                        <td>
                          {/* <button
                            onClick={() => paymentStatus(user)}
                            disabled={loading}
                          >
                            {loading ? "Loading..." : "Check Payment Status"}
                          </button> */}
                          <VerifyPayment
                            paymentData={{
                              payment_id: user.payment_id,
                              status: user.status,
                            }}
                            currentUser={{ uid: user.uid, year: user.year }}
                            onUpdate={handlePaymentUpdate}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Stacked Bar Chart for User Categories and Payment Methods */}
      <Row>
        <Col md={12}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={titleStyle}>
                Usuarios Inscritos y Método de Pago
              </Card.Title>
              <ResponsiveContainer width='100%' height={300}>
                <BarChart
                  data={userCategoryData}
                  margin={{ top: 20, right: 0, left: 0, bottom: 5 }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  {/* <XAxis dataKey="category" />
                                    <YAxis /> */}
                  <CartesianGrid strokeDasharray='3 3' stroke='#e0e0e0' />
                  <XAxis
                    dataKey='category'
                    tick={{ fontSize: 12, fontWeight: "bold", fill: "#555" }}
                  />
                  <YAxis
                    tick={{ fontSize: 14, fontWeight: "bold", fill: "#555" }}
                  />

                  <Tooltip
                    wrapperStyle={{
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                    contentStyle={{ color: "#333" }}
                    itemStyle={{ fontWeight: "bold" }}
                  />
                  <Legend
                    verticalAlign='top'
                    height={36}
                    wrapperStyle={{
                      fontFamily: "Arial, sans-serif",
                      fontSize: "14px",
                    }}
                  />
                  <Bar
                    dataKey='card'
                    stackId='a'
                    fill='#8884d8'
                    name='Tarjeta de crédito'
                  />
                  <Bar dataKey='qr' stackId='a' fill='#82ca9d' name='Pago QR' />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Dashboard
